export const seoProperty = {
  daskboard: 'Daskboard',
  organizations: 'Organizations',
  organizationsDetail: 'Organization details',
  organizationsAdd: 'Add organization',
  organizationsEdit: 'Edit organization',
  organizationCreate: 'Create organization',
  organizationsSite: 'Organization site',
  products: 'Products',
  productDetail: 'Product details',
  organizationsAddSite: 'Add site',
  organizationsEditSite: 'Edit site',
  warehouse: 'Warehouse',
  warehouseEdit: 'Edit warehouse',
  siteLocales: 'SiteLocales',
  siteLocalesAdd: 'Add locale',
  siteLocalesEdit: 'Edit locale',
  resources: 'Resources',
  resourceAdd: 'Add resource',
  resourceEdit: 'Edit resource',
  users: 'Users',
  userAdd: 'Add user',
  userEdit: 'Edit user',
  aggregators: 'Aggregators',
  aggregatorAdd: 'Add aggregator',
  aggregatorEdit: 'Edit aggregator',
  marketplaces: 'Marketplaces',
  marketplaceAdd: 'Add marketplace',
  marketplaceEdit: 'Edit marketplace',
  marketplaceTypes: 'Marketplace Types',
  marketplaceTypeAdd: 'Add marketplace type',
  relationshipAM: 'Aggregator and marketplace type relationship',
  relationshipAMAdd: 'Add aggregator and marketplace relationship',
  marketplaceRelationships: 'Marketplace relationships',
  marketplaceRelationshipAdd: 'Add marketplace relationship',
  marketplaceRelationshipEdit: 'Edit marketplace relationship',
  assignProductToMarketplace: 'Assign product to marketplace',
  orders: 'Orders',
  orderDetail: 'Order details',
  listingStatus: 'Listing status',
  defaultPropertyValues: 'Default property values',
  addDefaultPropertyValue: 'Add default property value',
  editDefaultPropertyValue: 'Edit default property value',
  productPropertyAdd: 'Product properties: Add property',
  productPropertyEdit: 'Product property: Edit property',
  productCategoryMappings: 'Product category mappings',
  productCategoryMappingAdd: 'Add product category mapping',
  productCategoryMappingEdit: 'Edit product category mappping',
  productPropertyMappings: 'Product property mappings',
  productPropertyMappingAdd: 'Add product property mapping',
  productPropertyMappingEdit: 'Edit product property mapping',
  productPropertyValueMapping: 'Value Mapping',
  courierMappings: 'Courier mappings',
  courierMappingAdd: 'Add courier mapping',
  courierMappingEdit: 'Edit courier mapping',
  importProductProperties: 'Import product properties',
  importResult: 'Import result',
  returnsRefunds: 'Returns refunds',
  deliveryTypeMappings: 'Delivery type mappings',
  deliveryTypeMappingAdd: 'Add delivery type mapping',
  deliveryTypeMappingEdit: 'Edit delivery type mapping',
  productCategories: 'Product categories',
  returnOrders: 'Return orders',
}
